module.exports = __webpack_public_path__ + "static/media/timed-shot.349c2651.svg";